import * as React from 'react'
import { colors } from '@lmc/common/constants'
import { CSSProperties, ReactNode } from 'react'
import AvatarLabel from '../AvatarLabel'
import { Text } from '../../general'
import CalendarIcon from './CalendarIcon.svg'
import styled from 'styled-components'
import { Carer } from '@lmc/ts-common'

export type CardProps = {
  localisation?: { title: string; review?: any }
  dateValue?: string
  rightChildren?: ReactNode
  leftChildren?: ReactNode
  style?: CSSProperties
  user?: Carer
}

const Card = ({
  localisation,
  dateValue,
  rightChildren,
  leftChildren,
  style,
  user,
}: CardProps) => (
  <Wrapper style={{ ...styles.container, ...style }}>
    <div style={styles.mainContainer}>
      {leftChildren || (
        <>
          {/* we need this ts-ignore because I wasn't able to make the type work for style (because of styled-components) */}
          {/* it is recomanded to change style using styled-components, not style prop */}
          {/* @ts-ignore */}
          <Text style={styles.nextReview}>{localisation?.title}</Text>
          <img
            style={styles.calendarIcon}
            alt="calendar-icon"
            src={CalendarIcon}
          />
          <DateText>{dateValue}</DateText>
          <div style={styles.user}>
            {user && (
              <AvatarLabel
                label={user.name as unknown as string}
                avatarSize={33}
                // @ts-ignore
                picture={
                  // @ts-ignore
                  user.picture !== '' && user.picture !== null
                    ? user.picture
                    : undefined
                }
              />
            )}
          </div>
        </>
      )}
      <div style={styles.floatRight}>{rightChildren}</div>
    </div>
  </Wrapper>
)

const Wrapper = styled.div`
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    overflow-x: auto;
  }
`

const DateText = styled(Text)`
  opacity: 64%;
`

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    padding: '6px 12px',
    alignItems: 'center',
    borderRadius: 15,
    background: colors.white,
  },
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  nextReview: {
    marginLeft: 4,
  },
  floatRight: { marginLeft: 'auto', marginRight: 4 },
  calendarIcon: { fontSize: 20, margin: 10, marginLeft: 20, marginRight: 20 },
  user: {
    marginLeft: 20,
  },
}

export default Card
